var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCryptoPlaceholderLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5137 27.6679C43.9908 23.4256 39.381 20.8322 34.1114 20.8322C26.1339 20.8322 19.9137 26.9706 19.9137 35C19.9137 43.0294 26.1339 49.7855 34.1114 49.7855C39.381 49.7855 43.9908 46.698 46.5137 42.4557H53.7445C50.7563 50.3727 43.0256 56 34.1114 56C22.5883 56 13 46.598 13 35C13 23.402 22.5883 14 34.1114 14C43.0256 14 50.7563 19.7508 53.7445 27.6679H46.5137V27.6679ZM57.3259 32.5295L50.0411 37.7177H40.9016C39.8372 40.4639 37.1726 42.4118 34.0517 42.4118C29.9943 42.4118 26.7052 39.1211 26.7052 35.0618C26.7052 31.0025 29.9943 27.7118 34.0517 27.7118C37.2196 27.7118 39.9189 29.7178 40.9503 32.5295H57.3259Z",
    fill: "#888888"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptoPlaceholderLogo);
export default __webpack_public_path__ + "static/media/Crypto_placeholder_logo.66d5b01df4a0d23dae55966972b4a2e2.svg";
export { ForwardRef as ReactComponent };